import { c as _c } from "react/compiler-runtime";
import { startupsUrl } from '@src/lib/startups-url';
import { usePathname, useSearchParams } from 'next/navigation';
export const useLoginHref = () => {
  const $ = _c(3);
  const pathname = usePathname();
  const params = useSearchParams();
  let t0;
  if ($[0] !== params || $[1] !== pathname) {
    const paramsObj = {};
    params.forEach((value, key) => paramsObj[key] = value);
    paramsObj.prompt = "login";
    t0 = startupsUrl(pathname, paramsObj);
    $[0] = params;
    $[1] = pathname;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};